import {CSSProperties} from 'react';

export const commonHeaderStyles: CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    height: '70px',
    padding: '0 20px',
};
